import { render, staticRenderFns } from "./priceLastMileList.vue?vue&type=template&id=161261b9&scoped=true&"
import script from "./priceLastMileList.vue?vue&type=script&lang=js&"
export * from "./priceLastMileList.vue?vue&type=script&lang=js&"
import style0 from "./priceLastMileList.vue?vue&type=style&index=0&id=161261b9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161261b9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('161261b9')) {
      api.createRecord('161261b9', component.options)
    } else {
      api.reload('161261b9', component.options)
    }
    module.hot.accept("./priceLastMileList.vue?vue&type=template&id=161261b9&scoped=true&", function () {
      api.rerender('161261b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Price/priceLastMileList.vue"
export default component.exports